import api from './client';

export interface NotificationItem {
  id: number;
  type: 'info' | 'success' | 'warning' | 'error';
  title: string;
  message: string;
  action_url?: string;
  action_label?: string;
  read: boolean;
  created_at: string;
}

export interface NotificationsResponse {
  notifications: NotificationItem[];
  unreadCount: number;
  total: number;
}

export async function fetchNotifications(limit = 50): Promise<NotificationsResponse> {
  const r = await api.get(`/api/notifications?limit=${limit}`);
  return r.data;
}

export async function markNotificationRead(id: number): Promise<void> {
  await api.put(`/api/notifications/${id}/read`);
}

export async function markAllNotificationsRead(): Promise<void> {
  await api.put('/api/notifications/read-all');
}

export async function deleteNotification(id: number): Promise<void> {
  await api.delete(`/api/notifications/${id}`);
}

export async function clearAllNotifications(): Promise<void> {
  await api.delete('/api/notifications');
}
